import React from 'react';
import { ArrowLeftOnRectangleIcon, UserIcon } from '@heroicons/react/24/outline';
import { adminService } from '../services/adminService';

const ImpersonationBanner: React.FC = () => {
  const isImpersonating = adminService.isImpersonating();
  
  if (!isImpersonating) {
    return null;
  }

  const handleReturnToAdmin = async () => {
    try {
      await adminService.returnToAdmin();
    } catch (error) {
      console.error('Error returning to admin:', error);
    }
  };

  const user = JSON.parse(localStorage.getItem('user') || '{}');

  return (
    <div className="bg-indigo-800 text-indigo-100 px-4 py-2">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <UserIcon className="h-4 w-4" />
          <span className="text-sm font-medium">
            Impersonating: {user.email || 'Unknown User'}
          </span>
        </div>
        <button
          onClick={handleReturnToAdmin}
          className="flex items-center space-x-1 text-sm font-medium hover:text-indigo-300 transition-colors"
        >
          <ArrowLeftOnRectangleIcon className="h-4 w-4" />
          <span>Return to Admin</span>
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;